<template>
  <div>
    <!-- <div class="top_box mar_top_20 flex Flexjustify flexcolumn">
      <div class="filter_box flex">
        <div>学段:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.stageId == '' ? 'active_area_info' : '']"
            @click="selectStage('')">
            不限
          </div>
          <div v-for="(item, index) in stageList" :key="index" class="area_info cursor_pointer"
            :class="[selectedInfo.stageId == item.stageId ? 'active_area_info' : '']"
            @click="selectStage(item.stageId)">
            {{ item.stageName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>年级:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.gradeId == '' ? 'active_area_info' : '']"
            @click="selectGrade('')">
            不限
          </div>
          <div v-for="(item, index) in gradeList" :key="index" class="area_info cursor_pointer"
            :class="[selectedInfo.gradeId == item.gradeId ? 'active_area_info' : '']"
            @click="selectGrade(item.gradeId)">
            {{ item.gradeName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>学科:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.subjectId == '' ? 'active_area_info' : '']"
            @click="selectSubjet('')">
            不限
          </div>
          <div v-for="(item, index) in subjectList" :key="index" class="area_info cursor_pointer"
            :class="[selectedInfo.subjectId == item.subjectId ? 'active_area_info' : '']"
            @click="selectSubjet(item.subjectId)">
            {{ item.subjectName }}
          </div>
        </div>
      </div>
    </div> -->
    <div class="menu_list flex Flexalign FlexBetween mt-10">
      <!-- <div class="flex Flexalign">
        <div class="menu_one mr-15" :class="gjkcTypeValue == '' ? 'active_menu' : ''" @click="changeGjkcType('')">全部</div>
        <div class="menu_one flex flexcolumn Flexalign cursor_pointer mr-15" v-for="(item, index) in gjkcTypeOptions"
          :key="index" @click="changeGjkcType(item.value)" :class="[item.value == gjkcTypeValue ? 'active_menu' : '']">
          {{ item.label }}
        </div>
      </div> -->
      <!-- <div class="flex Flexalign">筛选<el-image class="filter_icon ml-10" :src="imgPath('filter_icon.png')"></el-image>
      </div> -->
    </div>
    <div>
      <courseList :selectedInfo="selectedInfo" @getListTotal="getListTotal"></courseList>
    </div>
    <div class="pagination_box mar_top_10 flex FlexjustifyEnd" v-if="listTotal">
      <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]" :total="listTotal"
        v-model:page-size="selectedInfo.pageSize" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>
<script>
import courseList from "./courseList.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Index",
  components: {
    courseList,
  },
  computed: {
    ...mapState({
      stageList: (state) => state.filter.stageList,
      //   gradeList:(state) => state.filter.gradeList,
      //   subjectList: (state) => state.filter.subjectList,
      courseTypeList: (state) => state.filter.courseTypeList,
    }),
  },
  watch: {
    courseTypeList: {
      handler(value) {
        if (!this.$Tools.empty(value)) {
          this.gjkcTypeOptions = value;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      memberSelected: false,
      filterList: [],
      selectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 10, // 单页数量
      },
      gradeList: [],
      subjectList: [],
      courseList: [],
      listTotal: 0,
      gjkcTypeOptions: [],
      gjkcTypeValue: "",
    };
  },

  mounted() {
    this.gradeList = this.$store.state.filter.gradeList;
    this.subjectList = this.$store.state.filter.subjectList;
  },

  methods: {
    getListTotal(value) {
      if (value) this.listTotal = Number(value);
    },
    changePageSize() {
      console.log(this.selectedInfo)
    },
    handleCurrentChange(value) {
      this.selectedInfo.page = value;
      // this.getMyExamList();
    },
    changeStage(info) {
      this.stageValue = info.value;
    },
    // 选择学段
    selectStage(value) {
      this.selectedInfo.stageId = value;
      if (value == "") {
        this.gradeList = this.$store.state.filter.gradeList;
      } else {
        this.gradeList = this.$store.state.filter.gradeList.filter(
          (item) => item.stageId == value
        );
      }
      this.$Api.common
        .getSubject({ stageId: this.selectedInfo.stageId })
        .then((res) => {
          this.subjectList = res.data.data;
        })
        .catch(() => {

        });
    },
    // 选择年级
    selectGrade(value) {
      this.selectedInfo.gradeId = value;
    },
    // 选择学科
    selectSubjet(value) {
      this.selectedInfo.subjectId = value;
    },
    changeGjkcType(value){
      this.gjkcTypeValue = value;
    }
  },
};
</script>
<style lang="scss" scoped>
.btn {
  width: 140px;
  height: 36px;
  background: linear-gradient(90deg, #00d5c2, #00d498);
  border-radius: 18px;
  color: #fff;
  line-height: 36px;
  text-align: center;
}

.top_box {
  width: 100%;
  box-sizing: border-box;
  background: #f5f6f8;
  border-radius: 10px;
  padding: 15px;

  .filter_box {
    //   width: $pageMainWidth;
    line-height: 32px;

    // margin-bottom: 10px;
    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
    }

    .active_area_info {
      color: #13d6aa;
    }

    .filter {
      width: 95px;
      height: 32px;
      border-radius: 5px;
      border: 1px solid #e1e1e1;
      line-height: 32px;

      .filter_icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .sublist_box {
    margin-top: 10px;

    .opacity_box {
      opacity: 0;
    }

    .area_box {
      margin-left: 10px;
      height: 45px;
      background: #f3f3f3;
      border-radius: 10px;
    }

    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
      line-height: 45px;
    }

    .more_box {
      height: 45px;
      margin-right: 10px;
    }

    .filter_icon {
      width: 18px;
      height: 18px;
    }
  }
}

.menu_list {
  color: #909090;
  font-size: 14px;
  .menu_one {
    padding: 5px 15px;
  }

  .active_menu {
    background: #1FD294;
    border-radius: 16px;
    color: #fff;
  }
  .filter_icon{
    width: 16px;
    height: 16px;
  }
}

.hot_sell_course {
  width: 100%;
  background: #f3f3f3;
  border-radius: 100px 100px 0px 0px;
  padding: 30px 0;

  .hot_sell_course_top {
    //   width: $pageMainWidth;

    .hot_sell_course_top_title {
      font-weight: bold;
      font-size: 24px;
      color: #000000;
    }

    .hot_course_text {
      color: #999999;
      margin-left: 26px;
    }

    .active_text {
      color: #13d6aa;
    }
  }

  .more_btn {
    width: 70px;
    height: 35px;
    background: #f5f6f8;
    border-radius: 18px;
    color: rgba(153, 153, 153, 1);
  }
}

.course_rank {
  width: 100%;
  background: #ffffff;
  padding: 30px 0;
  background: rgba(243, 243, 243, 1);

  .week_course_rank {
    //   width: $pageMainWidth;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
  }
}
</style>
